import * as React from 'react'
import { createContext, PropsWithChildren, ReactElement, useMemo, useState } from 'react'
import HammockFormDialog from '../v2/components/Dialog/HammockFormDialog'
import { TimeOverviewDto } from '../config/registrationConfig'
import { BaseMutableOverviewDialogProps } from '../pages/BaseMutableOverview/BaseMutableOverview'
import TimeSuggestionMutationDialogBody, { TrackTimeSuggestionDto } from '../v2/components/Dialog/Registration/TimeSuggestionMutationDialogBody'

export type PopupContextType = {
    showTimeTrackingDialog: boolean
    setShowTimeTrackingDialog: (item: Partial<TrackTimeSuggestionDto>) => void
    cancelTimeTrackingDialog: (id: string) => void
}

const PopupContext = createContext<PopupContextType>(null)

export function PopupProvider(props: PropsWithChildren): ReactElement {
    const [showTimeTrackingDialog, setShowTimeTrackingDialog] = useState<Partial<TrackTimeSuggestionDto>>(undefined)

    const cancelTimeTrackingDialog = useMemo(
        () => (id: string) => {
            //Only cancel the time tracking when the ids match
            if (showTimeTrackingDialog?.timeSuggestionId === id) {
                setShowTimeTrackingDialog(undefined)
            }
        },
        [showTimeTrackingDialog],
    )

    return (
        <PopupContext.Provider
            value={{
                showTimeTrackingDialog: showTimeTrackingDialog !== undefined,
                setShowTimeTrackingDialog,
                cancelTimeTrackingDialog,
            }}
        >
            <>
                <div aria-label={'global-popups'}>
                    <HammockFormDialog<Partial<TrackTimeSuggestionDto>, BaseMutableOverviewDialogProps<TimeOverviewDto>>
                        open={showTimeTrackingDialog !== undefined}
                        setOpen={open => setShowTimeTrackingDialog(open ? showTimeTrackingDialog : undefined)}
                        dialogFormProps={() => ({ initialValues: { ...showTimeTrackingDialog }, onSubmit: () => {} })}
                        dialogFormBody={TimeSuggestionMutationDialogBody}
                        onDismiss={() => {
                            setShowTimeTrackingDialog(undefined)
                        }}
                    />
                </div>
                {props.children}
            </>
        </PopupContext.Provider>
    )
}

export default PopupContext
